module.exports = __webpack_public_path__ + "media/assets/link_field-687cf7e9c3e7a2f82e2f2d90388251e9.svg";